import { BlogArticleCard } from "components/Blog/SharedComponents/BlogArticleCard"
import { BlogArticleCardV2 } from "packages/acquisition/pages/blog/components/Shared/BlogArticleCard"
import React from "react"
import type {
  BlogV2ArticleType,
  BlogV2TagParsed,
  ReducedBlogV2ArticleType,
  ReducedBlogV2TagType,
} from "types/blog-v2-types"
import { isBlogPostV2Flat } from "types/typeGuards"

import { container } from "./MainPost.css"

type Props = {
  post: BlogV2ArticleType | ReducedBlogV2ArticleType
  tagDetails: BlogV2TagParsed | ReducedBlogV2TagType
}

export const MainPost: React.FC<Props> = ({ post, tagDetails }) => {
  if (isBlogPostV2Flat(post)) {
    return (
      <div className={container}>
        <BlogArticleCardV2
          article={post}
          desktopCols={1}
          width="100%"
          headingSize="h2"
        />
      </div>
    )
  }
  return (
    <div className={container}>
      <BlogArticleCard
        key={post.slug}
        post={post as BlogV2ArticleType}
        tag={tagDetails}
        desktopCols={1}
        width="100%"
        headingSize="h2"
      />
    </div>
  )
}
